import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../../shared/services/toastr.service';
import { FormOrganizer, IvfCycleEmbryoStorageAreaController, IvfCycleEmbryoStorageAreaRequest, IvfEmbryoGradingByCycleController, PatientInfoByFormattedCodeController, PatientInfoByFormattedCodeRequest, SaveEmbryoStorageAreaInfoRequest, SaveEmbryoStorageAreaInfoRequest2, SaveOTSectionDataRequest, TreatmentCyclesByActorCodeController, TreatmentCyclesByActorCodeRequest, EmbryoCount_GradeCode } from '../../../../models/actor/actor';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { AppData } from '../../../../models/appdata';
//import { DBOperation } from '../../../../../enums/enum';
import { SaveEmergencyContactInfoRequest } from '../../../../models/profileinfo/profileinfo.model';
import { ConsultantMapPipe } from '../../../../pipes/actors/actorIdentity.pipes';
import { ActorService } from '../../../../services/actor.service';
import { FDService } from '../../../../services/fd.service';
import { HCPService } from '../../../../services/hcp.service';
import { SpinnerService } from '../../../../services/spinner.service';




@Component({
  selector: 'embryostorelocation',
  templateUrl: './embryostorelocation.modal.html',
  styleUrls: ['./embryostorelocation.modal.scss']
})

export class NgbEmbryoStoreLocationModal implements OnInit {
  @ViewChild('f') IdentitiesForm: NgForm;

  @Input() Day: number;
  @Input() Embryocount: number;
  @Input() Grade1: string;
  @Input() Grade2: string;
  @Input() CycleCode: number;
  @Input() EmbryoGradingCode: number;
  @Input() Frozennumber: number;
  @Input() FrozenCount: number;
  @Input() ModalType: string;
  @Input() SelectedGrades: IvfEmbryoGradingByCycleController[];
  //@Input() CurrentActorAddEmergencyInfoRequest: EmergencyContactInfoRequest;
  @Input() ServiceCode: number;
  searchTitle: string;
  public ApiResData: ApiResponseModel;
  // public data: string;
  public isRequesting: boolean = false;
  public ShowService: boolean = true;
  public Listview: boolean = true;
  public AddEmbryo: boolean = false;
  public EditEmbryo: boolean = false;
  public BeforeEnterInput: boolean = true;
  public AfterEnterInput: boolean = false;
  public TotalValue: number;
    public TotalValue2: number;
    public Length: number;
  //public IsSelected: boolean;
  ExtractionDate: NgbDateStruct;
  CurrentSaveEmbryoStorageAreaInfoRequest: SaveEmbryoStorageAreaInfoRequest;
  CurrentSaveEmbryoStorageAreaInfoRequest2: SaveEmbryoStorageAreaInfoRequest2;
  CurrentEditEmbryoStorageAreaInfoRequest: SaveEmbryoStorageAreaInfoRequest;
  CurrentActorAddEmergencyInfoRequest: SaveEmergencyContactInfoRequest;
  CurrentSaveOTSectionDataRequest: SaveOTSectionDataRequest;
  CurrentPatientInfoByFormattedCodeController: PatientInfoByFormattedCodeController[];
  PatientDetails: PatientInfoByFormattedCodeController;
  CurrentPatientInfoByFormattedCodeRequest: PatientInfoByFormattedCodeRequest;
  CurrentTreatmentCyclesByActorCodeController: TreatmentCyclesByActorCodeController[];
  ActorCodeDetails: TreatmentCyclesByActorCodeController;
  SelectedTreatmentCycle: TreatmentCyclesByActorCodeController;

  CurrentTreatmentCyclesByActorCodeRequest: TreatmentCyclesByActorCodeRequest;
  LoadActorCodeData() {
    this.CurrentTreatmentCyclesByActorCodeRequest = new TreatmentCyclesByActorCodeRequest();
    //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
    this.CurrentTreatmentCyclesByActorCodeRequest.Branch = 0;
    this.CurrentTreatmentCyclesByActorCodeRequest.ActorCode = 0;
    this.CurrentTreatmentCyclesByActorCodeRequest.ConditionalOperator = 10;
    this.CurrentTreatmentCyclesByActorCodeRequest.FromDate = new Date();
    this.CurrentTreatmentCyclesByActorCodeRequest.ToDate = new Date();
    this.CurrentTreatmentCyclesByActorCodeRequest.CycleCode = this.CycleCode;
    //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
    //this.CurrentTreatmentCyclesRequest.From = 0;
    //this.CurrentTreatmentCyclesRequest.Status = "";
    this.CurrentTreatmentCyclesByActorCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetTreatmentCyclesByActorCodeController();
  }

  GetTreatmentCyclesByActorCodeController() {
    //this.StartRefreshing();


    this.actorservice.GetTreatmentCyclesByActorCodeController(this.CurrentTreatmentCyclesByActorCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentTreatmentCyclesByActorCodeController = this.ApiResData.Result;
          this.ActorCodeDetails = this.CurrentTreatmentCyclesByActorCodeController[0];
          //this.SelectedActorCode = this.CurrentTreatmentCyclesByActorCodeController[0].EggActorCode;
          //this.SelectedTreatmentCycle = this.CurrentTreatmentCyclesByActorCodeController[0];
          //this.LMPDate = this.SelectedTreatmentCycle.LMP;
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          //this.stopRefreshing();
          //this.LoadPlan();
          //this.LoadDSAData();
          this.LoadStoreData();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  CurrentIvfCycleEmbryoStorageAreaController: IvfCycleEmbryoStorageAreaController[];
  CurrentIvfCycleEmbryoStorageAreaRequest: IvfCycleEmbryoStorageAreaRequest;
  LoadStoreData() {
    this.CurrentIvfCycleEmbryoStorageAreaRequest = new IvfCycleEmbryoStorageAreaRequest();
    //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
    //this.CurrentIvfCycleEmbryoStorageAreaRequest.Branch = 0;
    this.CurrentIvfCycleEmbryoStorageAreaRequest.EmbryoGradingCode = this.EmbryoGradingCode;
    this.CurrentIvfCycleEmbryoStorageAreaRequest.ConditionalOperator = 10;

    this.CurrentIvfCycleEmbryoStorageAreaRequest.CycleCode = this.CycleCode;
    //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
    //this.CurrentTreatmentCyclesRequest.From = 0;
    //this.CurrentTreatmentCyclesRequest.Status = "";
    this.CurrentIvfCycleEmbryoStorageAreaRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetIvfCycleEmbryoStorageAreaController();
  }

  GetIvfCycleEmbryoStorageAreaController() {
    //this.StartRefreshing();


    this.actorservice.GetIvfCycleEmbryoStorageAreaController(this.CurrentIvfCycleEmbryoStorageAreaRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentIvfCycleEmbryoStorageAreaController = this.ApiResData.Result;
          this.TotalValue = this.CurrentIvfCycleEmbryoStorageAreaController.filter((item) => item.EmbryoCount)
            .map((item) => +item.EmbryoCount)
            .reduce((sum, current) => sum + current)

          //this.ActorCodeDetails = this.CurrentTreatmentCyclesByActorCodeController[0];
          //this.SelectedActorCode = this.CurrentTreatmentCyclesByActorCodeController[0].EggActorCode;
          //this.SelectedTreatmentCycle = this.CurrentTreatmentCyclesByActorCodeController[0];
          //this.LMPDate = this.SelectedTreatmentCycle.LMP;
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          //this.stopRefreshing();
          //this.LoadPlan();
          //this.LoadDSAData();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  public fo: FormOrganizer;
  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService, private spinner: NgxSpinnerService,
    private actorservice: ActorService, private fdservice: FDService, private filter: ConsultantMapPipe,
    private router: Router, private route: ActivatedRoute, private hcpservice: HCPService,
    private tosterservice: NGXToastrService) { }
  ngOnInit() {
    this.CurrentActorAddEmergencyInfoRequest = new SaveEmergencyContactInfoRequest();
    this.CurrentActorAddEmergencyInfoRequest.ConditionalOperator = 10;
    // this.CurrentActorAddEmergencyInfoRequest.ActorCode = this.ActorCode;
    this.CurrentActorAddEmergencyInfoRequest.EmergencyContactCode = 0;
    this.CurrentActorAddEmergencyInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentSaveOTSectionDataRequest = new SaveOTSectionDataRequest();
    this.CurrentSaveOTSectionDataRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentSaveEmbryoStorageAreaInfoRequest = new SaveEmbryoStorageAreaInfoRequest();
    this.CurrentSaveEmbryoStorageAreaInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentSaveEmbryoStorageAreaInfoRequest2 = new SaveEmbryoStorageAreaInfoRequest2();
    this.CurrentSaveEmbryoStorageAreaInfoRequest2.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentEditEmbryoStorageAreaInfoRequest = new SaveEmbryoStorageAreaInfoRequest();
    this.CurrentEditEmbryoStorageAreaInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

    this.ShowService = false;

    this.LoadActorCodeData();
    this.LoadRegistries();
    //alert(this.FrozenCount);
    //alert(this.TotalValue);
      // this.SetForm();
      //
      this.TotalValue2 = this.SelectedGrades.filter((item) => item.SelectedFreezeCount)
          .map((item) => +item.SelectedFreezeCount)
          .reduce((sum, current) => sum + current);
      this.Length = this.SelectedGrades.length;

  }




  LoadRegistries() {
    this.StartRefreshing();



    //this.GetBranchMap();


  }
  SelectedPatient(patient) {
    var data = patient.Title;
    // alert(data);
    let m = document.querySelector(patient.Title);
    //alert(m);
    if (m) {
      m.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
    }
    //data.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
  }
  SelectedTile(SelectedTitle1) {
    //alert(SelectedTitle1.Title);
    //var data= SelectedTitle1.Title;
    //alert(data);
    let m = document.querySelector("");
    if (m) {
      m.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
    }
  }
  onSubmit() {
    this.spinner.show();
    this.CurrentSaveEmbryoStorageAreaInfoRequest.CycleCode = this.CycleCode;
    this.CurrentSaveEmbryoStorageAreaInfoRequest.ConditionalOperator = 10;
    this.CurrentSaveEmbryoStorageAreaInfoRequest.EmbryoGradingCode = this.EmbryoGradingCode;
    this.CurrentSaveEmbryoStorageAreaInfoRequest.StorageAreaCode = 0;
    // this.CurrentSaveEmbryoStorageAreaInfoRequest.StoreEmbryoCount = this.Frozennumber;
    //this.CurrentSaveEmbryoStorageAreaInfoRequest.
    //this.CurrentSaveEmbryoGradingInfoRequest.DOC = this.DOC;
    // this.CurrentSaveEmbryoStorageAreaInfoRequest.MultiNucleation = "";
    // this.CurrentSaveEmbryoGradingInfoRequest.CreatedUser = AppData.Instance().UserLoginDetails.EmployeeCode;
    //this.CurrentSaveEmbryoGradingInfoRequest.CreatedUserName = AppData.Instance().UserLoginDetails.UserName;


    this.actorservice.SaveEmbryoStorageAreaInfo(this.CurrentSaveEmbryoStorageAreaInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.GetActorEducationInfoController();
            //this.GetResourceIdentificationByDateInfoController();
            // alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.Listview = true;
            this.EditEmbryo = false;
            this.LoadStoreData();
            this.AddEmbryo = false;
            this.spinner.hide();
            //this.activeModal.close();
            //this.clearData();
            // this.LoadScansData();
            this.stopRefreshing();

          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");

            this.spinner.hide();
            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            //alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            alert(this.ApiResData.ErrorData);


          }
          else {
            this.spinner.hide();
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.stopRefreshing();
          }
        }
      );


  }

  //GetUsedCount() {
  //    this.CurrentIvfCycleEmbryoStorageAreaController.sort( 
  //        function (a, b) {
  //            var c = a.EmbryoCount + b.EmbryoCount
  //            return c
  //        }



  //    )
  //}
  //CurrentSelectedGrades: new Array<SelectedGrades>;
  onSubmit2() {
    this.spinner.show();
    this.CurrentSaveEmbryoStorageAreaInfoRequest2.CycleCode = this.CycleCode;
    this.CurrentSaveEmbryoStorageAreaInfoRequest2.ConditionalOperator = 10;
    this.CurrentSaveEmbryoStorageAreaInfoRequest2.EmbryosForStore = new Array<EmbryoCount_GradeCode>();
    this.SelectedGrades.forEach((v, i, a) => {
      var item: EmbryoCount_GradeCode = new EmbryoCount_GradeCode();
      item.EmbryoGradingCode = v.EmbryoGradingCode;
      item.StoreEmbryoCount = v.SelectedFreezeCount;
      this.CurrentSaveEmbryoStorageAreaInfoRequest2.EmbryosForStore.push(item);
    });
    this.CurrentSaveEmbryoStorageAreaInfoRequest2.TotalCount = this.TotalValue2;
    // this.CurrentSaveEmbryoStorageAreaInfoRequest2.EmbryosForStore[].EmbryoGradingCode = this.SelectedGrades.filter(function (a) { return a.EmbryoGradingCode });
    //this.CurrentSaveEmbryoStorageAreaInfoRequest2.EmbryosForStore.StoreEmbryoCount = this.TotalValue2;
    this.CurrentSaveEmbryoStorageAreaInfoRequest2.StorageAreaCode = 0;
    // this.CurrentSaveEmbryoStorageAreaInfoRequest.StoreEmbryoCount = this.Frozennumber;
    //this.CurrentSaveEmbryoStorageAreaInfoRequest.
    //this.CurrentSaveEmbryoGradingInfoRequest.DOC = this.DOC;
    // this.CurrentSaveEmbryoStorageAreaInfoRequest.MultiNucleation = "";
    // this.CurrentSaveEmbryoGradingInfoRequest.CreatedUser = AppData.Instance().UserLoginDetails.EmployeeCode;
    //this.CurrentSaveEmbryoGradingInfoRequest.CreatedUserName = AppData.Instance().UserLoginDetails.UserName;


    this.actorservice.SaveEmbryoStorageAreaInfo2(this.CurrentSaveEmbryoStorageAreaInfoRequest2)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.GetActorEducationInfoController();
            //this.GetResourceIdentificationByDateInfoController();
            // alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            //this.Listview = true;
            //this.EditEmbryo = false;
            //this.LoadStoreData();
            //this.AddEmbryo = false;
            this.spinner.hide();
            this.activeModal.close();
            //this.clearData();
            // this.LoadScansData();
            this.stopRefreshing();

          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");

            this.spinner.hide();
            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            //alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            alert(this.ApiResData.ErrorData);


          }
          else {
            this.spinner.hide();
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.stopRefreshing();
          }
        }
      );


  }

  criteriaChange(value: any) {

  }
  numberchange(event: any) {
    if (event != null) {
      this.BeforeEnterInput = false;
      this.AfterEnterInput = true;
    }

  }

  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }
  AddEmbryostore() {
    this.Listview = false;
    this.AddEmbryo = true;
    this.EditEmbryo = false;
  }
  EditEmbryoData(l: IvfCycleEmbryoStorageAreaController) {
    this.CurrentEditEmbryoStorageAreaInfoRequest.CryoTopColor = l.CryoTopColor;
    this.CurrentEditEmbryoStorageAreaInfoRequest.Goblet = l.Goblet;
    this.CurrentEditEmbryoStorageAreaInfoRequest.Hexa = l.Hexa;
    this.CurrentEditEmbryoStorageAreaInfoRequest.Viso = l.Viso;
    this.CurrentEditEmbryoStorageAreaInfoRequest.StoreEmbryoCount = l.EmbryoCount;
    this.CurrentEditEmbryoStorageAreaInfoRequest.CycleCode = l.CycleCode;
    this.CurrentEditEmbryoStorageAreaInfoRequest.EmbryoGradingCode = l.EmbryoGrading;
    this.CurrentEditEmbryoStorageAreaInfoRequest.StorageAreaCode = l.IvfCycleEmbryoStorageAreaCode;

    this.CurrentEditEmbryoStorageAreaInfoRequest.CanisterNo = l.CanisterNo;
    this.AddEmbryo = false;
    this.EditEmbryo = true;
    this.Listview = false;
  }
  //OnEdditSubmit() {

  //}
  OnEdditSubmit() {
    this.spinner.show();
    //this.CurrentSaveEmbryoStorageAreaInfoRequest.CycleCode = this.CycleCode;
    this.CurrentEditEmbryoStorageAreaInfoRequest.ConditionalOperator = 20;
    // this.CurrentEditEmbryoStorageAreaInfoRequest.StoreEmbryoCount = this.Frozennumber;
    //this.CurrentSaveEmbryoStorageAreaInfoRequest.EmbryoGradingCode = this.EmbryoGradingCode;
    //this.CurrentSaveEmbryoGradingInfoRequest.DOC = this.DOC;
    // this.CurrentSaveEmbryoStorageAreaInfoRequest.MultiNucleation = "";
    // this.CurrentSaveEmbryoGradingInfoRequest.CreatedUser = AppData.Instance().UserLoginDetails.EmployeeCode;
    //this.CurrentSaveEmbryoGradingInfoRequest.CreatedUserName = AppData.Instance().UserLoginDetails.UserName;


    this.actorservice.SaveEmbryoStorageAreaInfo(this.CurrentEditEmbryoStorageAreaInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.GetActorEducationInfoController();
            //this.GetResourceIdentificationByDateInfoController();
            // alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.LoadStoreData();
            this.Listview = true;
            this.EditEmbryo = false;
            //this.activeModal.close();
            //this.clearData();
            // this.LoadScansData();
            this.spinner.hide();
            this.stopRefreshing();

          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.spinner.hide();

            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            //alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            alert(this.ApiResData.ErrorData);


          }
          else {
            this.spinner.hide();
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.stopRefreshing();
          }
        }
      );


  }
  OnEdditSubmit1() {
    this.spinner.show();
    //this.CurrentSaveEmbryoStorageAreaInfoRequest.CycleCode = this.CycleCode;
    this.CurrentEditEmbryoStorageAreaInfoRequest.ConditionalOperator = 20;
    this.CurrentEditEmbryoStorageAreaInfoRequest.StoreEmbryoCount = this.Frozennumber;
    //this.CurrentSaveEmbryoStorageAreaInfoRequest.EmbryoGradingCode = this.EmbryoGradingCode;
    //this.CurrentSaveEmbryoGradingInfoRequest.DOC = this.DOC;
    // this.CurrentSaveEmbryoStorageAreaInfoRequest.MultiNucleation = "";
    // this.CurrentSaveEmbryoGradingInfoRequest.CreatedUser = AppData.Instance().UserLoginDetails.EmployeeCode;
    //this.CurrentSaveEmbryoGradingInfoRequest.CreatedUserName = AppData.Instance().UserLoginDetails.UserName;


    this.actorservice.SaveEmbryoStorageAreaInfo(this.CurrentEditEmbryoStorageAreaInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.GetActorEducationInfoController();
            //this.GetResourceIdentificationByDateInfoController();
            // alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.LoadStoreData();
            this.Listview = true;
            this.EditEmbryo = false;
            //this.activeModal.close();
            //this.clearData();
            // this.LoadScansData();
            this.spinner.hide();
            this.stopRefreshing();

          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.spinner.hide();

            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            //alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            alert(this.ApiResData.ErrorData);


          }
          else {
            this.spinner.hide();
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.stopRefreshing();
          }
        }
      );


  }
  Back() {
    this.Listview = true;
    this.AddEmbryo = false;
    this.EditEmbryo = false;
  }




}
